module.exports = __webpack_public_path__ + "sunsemweb/img/dt.617fc956.png";